// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","colorBlack":"rgb(14, 19, 24)","colorBlackA07":"rgba(14, 19, 24, 0.07)","colorWhite":"#fff","header":"_2N25CEEkTF2oJXh7A4qgrN","headerSpacer":"_3ZOkUNPLctLVFNXPQ37b9A","search":"_3nfMtjALhAFCgeaewzWENA","button":"kcmqBkAW0gRFNIWIlrRfa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/header/header.css
// module id = 922
// module chunks = 0